import React, { useEffect, useState } from "react";
import { IChartOption } from "src/shared/models/IDashboards.models";
import ReactECharts from 'echarts-for-react';
import { NoDataChart } from "./NoDataChart";

interface FormProps {
  details: IChartOption;
  titleChart: string;
  titleChartNoData: string;
  typeIcon?: boolean;
}

export const EchartPie = React.memo(({ details, titleChart, titleChartNoData, typeIcon = false }: FormProps) => {
  const chartColors = ["#2196F3", "#79C4FF", "#FFB74D"]; //#FFA500
  const [option, setOption] = useState<any>(null);

  useEffect(() => {
    if(details?.labels?.length > 0)
      loadData()
  }, [details]);

  const loadData = () => {
    const dataInfo = 
      details?.labels?.map((y: any, index: number) => {
        return { value: details?.series[index] ?? 0, name: y };
      }) || {}
    setOption(
    {
      title : {
        text: titleChart,
        subtext: "",//'subtitulo'
        x:'left',
        y: 20,
        avoidLabelOverlap: true,
        textStyle: {
          fontSize: 16,
          fontFamily: 'Open Sans,sans-serif',
        },
      },
      color: chartColors,
      textStyle: {
        fontSize: 11,
        fontFamily: 'Open Sans,sans-serif',
      },
      tooltip : {
        trigger: 'item',
        formatter: "{a} <br/>{b} : {c} ({d}%)"
      },
      legend: {
        orient: 'vertical',
        // right: 'right', // Coloca la leyenda en la parte derecha
        // top: 'middle', // Coloca la leyenda en la parte media

        bottom: 20, // Coloca la leyenda en la parte media
        right: 20, // Coloca la leyenda en la parte inferior
        data: details?.labels ?? [],
        avoidLabelOverlap: true,
        icon: 'circle', // Cambiar la forma de los íconos de la leyenda a círculos
      },
      series : [
        {
          name: titleChart,
          type: "pie",
          avoidLabelOverlap: true,
          data: dataInfo,          
          fontFamily: 'Open Sans,sans-serif',
          position: 'left',
          center: ['25%', '60%'],
          top: '20%', // Ajusta este valor para mover el gráfico hacia abajo
          itemStyle: {
            fontFamily: 'Open Sans,sans-serif',
            emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          textStyle: {
            fontFamily: 'Open Sans,sans-serif',
          },
          label: {
            show: false, // Ocultar las etiquetas
          },
          labelLine: {
            show: false, // Ocultar las líneas de las etiquetas
          },
        }
      ]
    })
  }

  if (!option && details?.labels?.length > 0) return <></>;

  return (
    <>
    {
      details?.labels?.length > 0 ? 
      <ReactECharts
        option={option}
        style={{ height: 170 }}
        // style={{ height: 270, marginTop:"10px" }}
        onEvents={{
        }}
        />
      : <NoDataChart titleChart={titleChart} titleChartNoData={titleChartNoData} typeIcon={typeIcon} />
    }
    </>
  );
});